import React from 'react';
import { FormikErrors } from 'formik';
import { AuthMarketing, Button, FieldWrapper, FormError, LayoutSplit, Password } from 'components';
import Form from 'components/Form/Form';
import { IApiErrorPayloadWithCode, IResetPasswordPayloadProps } from 'types';
import { AuthContainer, AuthContent, AuthContentInner, AuthFieldset } from './styles';

interface IPasswordResetCreateNewProps {
  handleSubmit: () => void;
  isLoading: boolean;
  apiErrors: IApiErrorPayloadWithCode;
  authHeader: React.ReactNode;
  onNewForm: () => void;
  validateField: (field: 'password') => boolean;
  errors: FormikErrors<IResetPasswordPayloadProps>;
  getFieldProps: (fieldName: string) => any;
  isValid: boolean;
  dirty: boolean;
  formId: string;
}

const PasswordResetCreateNew: React.FC<IPasswordResetCreateNewProps> = ({ validateField, authHeader, formId, errors, getFieldProps, isLoading, dirty, isValid, apiErrors, handleSubmit, onNewForm }) => (
  <LayoutSplit
    left={
      <AuthContainer>
        <AuthContent>
          <AuthContentInner>
            {authHeader}
            <Form onNewForm={onNewForm} onSubmit={handleSubmit} formId={formId}>
              <AuthFieldset>
                <FieldWrapper data-cy="password-field" label="New Password" message={validateField('password') ? errors.password : ''} hasError={validateField('password')}>
                  <Password data-cy="password-input" id="password" {...getFieldProps('password')} />
                </FieldWrapper>
              </AuthFieldset>
              {apiErrors?.errorMessages &&
                apiErrors?.errorMessages.map((error: string, index: number) => (
                  <FormError key={`error-message-${index}`} data-cy="form-error">
                    {error}
                  </FormError>
                ))}
              <Button data-cy="submit-button" label="Submit" type="submit" appearance="primary" size="large" disabled={isLoading || !(isValid && dirty)} isProcessing={isLoading} />
            </Form>
          </AuthContentInner>
        </AuthContent>
      </AuthContainer>
    }
    right={<AuthMarketing />}
  />
);

export default PasswordResetCreateNew;
